import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
// Import your translation function - adjust the import path as needed
import { useTranslation } from 'react-i18next'; // or your preferred i18n library

interface Props{
    inverted?: boolean;
    content?: string
}

export default function LoadingComponent({inverted = true, content}: Props){
    const { t } = useTranslation(); // or your translation hook
    
    return(
        <Dimmer active = {true} inverted = {inverted}>
            <Loader content ={content || t('loading.default')}/>
        </Dimmer>
    )
}